module.exports = __webpack_public_path__ + "static/media/trimmer.5d9dc938.svg";